module.exports = __webpack_public_path__ + "static/media/totalOrder.b35267b2.svg";